import {
  ShippingCoverageZodSchema,
  type ShippingCoverageInterface,
} from "@redotech/redo-model/integration/redo-in-shipping/ris";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export interface GetRisIntegrationDef {
  name: "getRisIntegration";
  input: z.ZodObject<{
    teamId: z.ZodType<string>;
    integrationType: z.ZodString;
  }>;
  output: z.ZodObject<{
    risIntegration: z.ZodNullable<ShippingCoverageInterface>;
    hasShopifyIntegration: z.ZodBoolean;
    isRisEnabled: z.ZodBoolean;
  }>;
}

export const GetRisIntegrationResponseSchema = z.object({
  risIntegration: (
    ShippingCoverageZodSchema as ShippingCoverageInterface
  ).nullable(),
  hasShopifyIntegration: z.boolean(),
  isRisEnabled: z.boolean(),
});
export type GetRisIntegrationResponse = z.infer<
  typeof GetRisIntegrationResponseSchema
>;

export const getRisIntegration: GetRisIntegrationDef = {
  name: "getRisIntegration" as const,
  input: z.object({ teamId: zExt.objectId(), integrationType: z.string() }),
  output: GetRisIntegrationResponseSchema,
};
